<template>
  <SearchBar v-model:search-text="searchText" :show-refresh="false" @input="onFilterTextBoxChanged"></SearchBar>
  <ag-grid-vue
    theme="legacy"
    :rowData="lookupItems"
    :columnDefs="colDefs"
    :defaultColDef="defaultColDefs"
    :autoSizeStrategy="{ type: 'fitGridWidth' }"
    :suppressCellFocus="true"
    :suppressDragLeaveHidesColumns="true"
    class="py-3 h-[600px]"
    :class="darkVal ? 'ag-theme-quartz-dark' : 'ag-theme-quartz'"
    rowSelection="single"
    @row-selected="selectEntity"
    @grid-ready="(event: GridReadyEvent) => gridApi = event.api"
  ></ag-grid-vue>
</template>

<script setup lang="ts">
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import type { Entity } from "@/types/Entity";
import { usePropsStore } from "@/stores/props";
import type { GridApi, GridReadyEvent, RowSelectedEvent } from "ag-grid-community";

const propsStore = usePropsStore();
const darkVal = computed<boolean>(() => propsStore.darkMode);

interface Props {
  lookupItems: Entity[];
}
const props = defineProps<Props>();

const defaultColDefs = {
  filter: true,
  floatingFilter: false,
  cellDataType: "text",
};

const colDefs = ref([
  {
    field: "firstName",
    headerName: "First Name",
  },
  {
    field: "lastName",
    headerName: "Last Name",
  },
  {
    field: "companyName",
    headerName: "Company",
  },
  {
    field: "email",
    headerName: "E-mail",
  },
]);

const emit = defineEmits<{
  entitySelected: [entity: Entity];
}>();
const selectEntity = (event: RowSelectedEvent) => {
  emit("entitySelected", event.node.data);
};

const gridApi = ref<GridApi>();
const searchText = ref("");

const onFilterTextBoxChanged = (): void => {
  if (gridApi.value == null) return;
  gridApi.value.setGridOption("quickFilterText", searchText.value);
  if (gridApi.value.getDisplayedRowCount() > 0) gridApi.value.hideOverlay();
  else gridApi.value.showNoRowsOverlay();
};
</script>
